<app-page class="width-100" pageTitle="Settings">
  <div class="settings-page" [style.height]="getPageHeight()">
    @if (pilotData$ | async; as pilotData) {
    <app-labeled-container class="width-100" label="PVDs">
      @for (item of homeSettings; track $index; let last = $last) {
      <app-category-item
        [label]="item.label"
        [icon]="item.icon"
        [value]="item.value"
        [underlined]="!last"
        [isLoading]="pilotData.isLoading"
        (click)="navigateTo(item.route)"
      />
      }
    </app-labeled-container>
    } @if (settings$ | async; as settings) {
    <app-labeled-container class="width-100" label="Plans">
      @for (item of plansSettings; track $index; let last = $last) {
      <app-category-item
        [label]="item.label"
        [icon]="item.icon"
        [value]="item.value"
        [underlined]="!last"
        [isLoading]="settings.isLoading"
        (click)="navigateTo(item.route)"
      />
      }
    </app-labeled-container>
    }
  </div>
</app-page>
